// extracted by mini-css-extract-plugin
module.exports = {"products":"styles_products__i4b5j"};